import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class ReportingPeriodDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      excluded_reporting_periods,
      defaultDropdownMsg,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          searchParams={{
            excluded_reporting_periods
          }}
          dropdownType='reporting_period'
          type='reporting_period'
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
          onPostChange={onPostChange}
          defaultDropdownMsg={defaultDropdownMsg}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ReportingPeriodDropdown);
